import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { hasRolloutFeature, ROLLOUT_FEATURES } from "../../utils/rolloutFeatures";
import LegacyPage from "./Legacy";
import RolloutPage from "./Rollout";

const AiAgents = props => {
  const { user } = useContext(AuthContext);
  const Page = hasRolloutFeature(user, ROLLOUT_FEATURES.AI)
    ? RolloutPage
    : LegacyPage;
  return <Page {...props} />;
};

export default AiAgents;
